import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Button,
  Input,
  ModalBody,
  ModalFooter
} from 'reactstrap'
import { FormattedMessage } from 'react-intl'

import Modal from '../../molecules/Modal'
import ResultLayerItem from '../../atoms/ResultLayerItem'
import { injectIntl } from 'react-intl'

const ButtonOk = styled(Button)`
  &&& {
    height: 40px;
    padding: 0 32px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 40px;
    background-color: #00a79d;
    border-color: #00a79d;
  }
`

const Body = styled(ModalBody)`
  height: 100%;
  max-height: 360px;
  overflow-y: auto;
`

const InputWrapper = styled.div`
  padding: 1rem 1rem 0;
`

class SearchLayer extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      layers: [],
      search: ''
    }

    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  onChangeSearch (el) {
    this.setState({
      [el.target.name]: el.target.value
    })
  }

  onClick () {
    const { addLayers, onToggleModal } = this.props
    const { layers } = this.state

    addLayers(layers)
    onToggleModal()
  }

  onSelect (el) {
    const { layers } = this.state
    const nLayers = Array.from(layers)

    const layer = el.target.dataset.key
    const selected = el.target.checked

    if (selected) {
      nLayers.push(layer)
    } else {
      const layerIndex = nLayers.indexOf(layer)

      nLayers.splice(layerIndex, 1)
    }

    this.setState({
      layers: nLayers
    })
  }

  render () {
    const { search } = this.state
    const { layers, onToggleModal, show } = this.props

    const searchRegex = new RegExp(search, 'i')

    if (!layers) { return null }

    const availableLayers = layers.data
      .filter(baseLayer => {
        return !layers.layers.find(item => item.id === baseLayer.nm_layer)
      });

    return (
      <Modal
        className='modal-lg'
        title='layer.opt.addLayer'
        onToggle={onToggleModal}
        show={show}
      >
        <InputWrapper>
          <Input
            onChange={this.onChangeSearch}
            name='search'
            placeholder={this.props.intl.formatMessage({ id: 'layer.opt.search' })}
            value={search}
          />
        </InputWrapper>
        <Body>
          { availableLayers.length === 0 && <FormattedMessage id="layer.opt.addAll" /> }
          { layers.data
            .filter(baseLayer => {
              const isLayerSelected = layers.layers.find(item => item.id === baseLayer.nm_layer)
              const formattedLayerName = this.props.intl.formatMessage({ id: `name.layer.${ baseLayer.id_layer }` })
              const isSearched = formattedLayerName.search(searchRegex) >= 0

              return !isLayerSelected && isSearched
            })
            .sort((baseLayerA, baseLayerB) => {
              const formattedLayerNameA = this.props.intl.formatMessage({ id: `name.layer.${ baseLayerA.id_layer }` })
              const formattedLayerNameB = this.props.intl.formatMessage({ id: `name.layer.${ baseLayerB.id_layer }` })

              return formattedLayerNameA.localeCompare(formattedLayerNameB);
            })
            .map(baseLayer => {
              const props = {
                item: baseLayer,
                onSelect: this.onSelect,
                value: false
              }

              return (<ResultLayerItem key={baseLayer.id_layer} {...props} />)
            })
          }
        </Body>
        <hr />
        <ModalFooter>
          <ButtonOk
            onClick={this.onClick}><FormattedMessage id="layer.opt.add" /></ButtonOk>
        </ModalFooter>
      </Modal>
    )
  }
}

SearchLayer.propTypes = {
  addLayers: PropTypes.func.isRequired,
  layers: PropTypes.object.isRequired,
  onToggleModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}

export default injectIntl(SearchLayer)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchLayer/SearchLayer.js